import { ResponsiveBar } from '@nivo/bar';
import { ResponsiveLine } from '@nivo/line';
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { loginState } from "../../stores/loginState";
import { useGetMonthChart } from "../../api/dashboard/useGetMonthChart";
import { chartLegends } from "../../utils/chartLegends";
import { formatNumberCommas } from "../../utils/formatNumberCommas";
import ReactDOM from "react-dom";

const YearChart = (props) => {
  // NOTE 상태 변수 선언
  const [monthData, setMonthData] = useState([]);
  const login = useRecoilValue(loginState);

  // TODO 주간 운영 현황 데이터 호출 API
  const { mutate: monthChartMutate } = useGetMonthChart(setMonthData);

  // NOTE 페이지 로드 시 데이터 호출
  useEffect(() => {
    monthChartMutate();
  }, [monthChartMutate]);

  // NOTE 데이터 정제
  const revertMonthDataCountNumber = monthData?.map((item) => {
    const countArray = Array.isArray(item.count) ? item.count : [item.count];
  
    // countIn과 countOut 값을 배열 디스트럭처링으로 바로 설정
    let [countIn, countOut = 0] = countArray.map(count => parseInt(count, 10));
  
    // HANDDEX 데이터가 있는 경우 해당 값을 사용
    if (countArray.length === 3) {
      countIn = parseInt(countArray[0], 10);
      countOut = parseInt(countArray[1], 10);
    }
  
    // 필요한 값을 리턴하거나 추가 로직을 여기에 작성
    return {
      scandate: item.scandate,
      countIn,
      countOut,
      total: countIn + countOut
    };
  });

  const lineChartData = [
    {
      id: "total",
      data: [
        { x: "Start", y: 0 },
        ...revertMonthDataCountNumber.map((item) => ({
          x: item.scandate,
          y: item.total,
          a: item.countIn,
          b: item.countOut,
        })),
        { x: "End", y: 0 },
      ],
    }
  ];

  // NOTE 표기 용어 일부 변경
  const legendsData = chartLegends(login.company);

  // 라인 차트 맞춤용 데이터 길이 계산
  const dataLength = lineChartData[0].data.length;

  // NOTE 마우스 올릴 시 툴팁 창 잘리는 현상 수정
  const renderTooltip = (content) => {
    return ReactDOM.createPortal(content, document.getElementById('tooltip2'));
  };

  return (
    <div id="tooltip2" style={{ position: 'relative', width: '740px', height: '400px' }}>
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
      {/* 바 차트 */}
        <ResponsiveBar
          data={revertMonthDataCountNumber}
          keys={["countIn", "countOut"]}
          indexBy="scandate"
          margin={{ top: 100, right: 100, bottom: 50, left: 60 }}
          padding={0.4}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          colors={["#9ea3ec", "#ec9e9e"]}
          colorBy="id"
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          axisRight={null}
          axisLeft={{
            tickValues: 5,
          }}
          enableTotals={formatNumberCommas((e) => e)}
          totalsOffset={30}
          labelTextColor="#333"
          labelSkipWidth={10}
          labelSkipHeight={12}
          valueFormat={">-,"}
          legends={[
            {
              color: props.theme.black1,
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              justify: false,
              translateX: 120,
              translateY: 0,
              itemsSpacing: 2,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 13,
              data: legendsData,
            },
          ]}
          role="application"
          barAriaLabel={(e) =>
            e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          }
          theme={{
            color: props.theme.black1,
            textColor: props.theme.black1,
            fontSize: 12,
            text: {
              fill: props.theme.black1,
            },
          }}
        />
      </div>
      <div style={{ position: 'absolute', width: "580px", height:"360px", overflow: "hidden", top: -5, left: 60}}>
      <div style={{ position: 'absolute', width: `${706-(dataLength*8.5)}px`, height:"260px", left: (-62.5+(dataLength*4.25)), top:100}}>
      {/* 라인 차트 */}
        <ResponsiveLine
          data={lineChartData}
          yScale={{
            type: 'linear',
            min: '0',
            stacked: true,
            reverse: false
          }}
          margin={{top: 5, bottom: 5}}
          curve='monotoneX'
          axisTop={null}
          axisRight={null}
          axisBottom={null}
          axisLeft={null}
          enablePoints={true}
          enableArea={true}
          pointColor={props.theme.white1}
          pointBorderColor={props.theme.yellow1}
          colors={props.theme.yellow1}
          lineWidth={2}
          enableGridX={false}
          enableGridY={false}
          pointSize={6}
          useMesh={true}
          pointBorderWidth={2}
          isInteractive={true}
          tooltip={({ point }) => renderTooltip(
            point.data.a > -1 && <div style={{
              padding: "5px 10px",
              background: props.theme.white1,
              border: `solid 1px ${props.theme.black2}`,
              display: "flex",
              alignItems: "center",
              position: "absolute",
              top: `${point.y + 30}px`, // 정확한 위치 계산
              left: `${point.x - 20}px`,
              pointerEvents: 'none',
              transform: 'translateY(10px)',
              transition: '0.7s',
            }}>
              <strong>{login.company === "LOGEN" ? "배송입고" : login.company === "LOTTE" ? "도착" : login.company === "KPC" ? "일반입고" : "간선하차"} : {formatNumberCommas(point.data.a)} 건<br/>
              {login.company === "LOGEN" ? "집하출고" : login.company === "LOTTE" ? "출발" : login.company === "KPC" ? "SLX집하" : "간선상차"} : {formatNumberCommas(point.data.b)} 건</strong>
            </div>,
            document.getElementById('tooltip2')
          )}
        />
      </div>
      </div>
    </div>
  );
};

export default YearChart;
